<script>
    import AuthContext from '../layouts/AuthContext.svelte';
    import BigSpinner from '../components/BigSpinner.svelte';
    import { currentUser } from '../stores/currentUser';
    import firebase from '../firebase';
    import functions from '../functions';
	
    const promise = functions.get('userData');
</script>

<AuthContext title="Users">
	<div class="page">
        <div class="layout">
            {#await promise}
                <div class="layout__column layout__column--centre">
                    <div class="layout__item">
                        <BigSpinner colour="#333" />
                    </div>
                </div>
            {:then result}
                <div class="layout__column">
                    {#each result.users as user}
                        <div class="layout__item">
                            User: [ Name: {user.name}, Email: {user.email} ]
                        </div>
                    {/each}
                </div>
            {:catch error}
                <div class="layout__column">
                    <div class="layout__item">
                        {error.message}
                    </div>
                </div>
            {/await}
        </div>
	</div>
</AuthContext>